export default {"src":"/_next/static/media/x.9bb12e64.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};